import { render, staticRenderFns } from "./PolizasRHCard.vue?vue&type=template&id=4ce6bc86&scoped=true&"
import script from "./PolizasRHCard.vue?vue&type=script&lang=js&"
export * from "./PolizasRHCard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasRHCard.vue?vue&type=style&index=0&id=4ce6bc86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce6bc86",
  null
  
)

export default component.exports